import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, X, ArrowRight } from "lucide-react";
import api from "../api";
import { useLocationFilter } from "../context/LocationContext";
import { useLang } from "../context/LanguageContext";

// Only shown to a shopper who has already shared their position, and only when the nearest city
// page actually has deals on it.
export const NearestCityBanner = () => {
  const { gps } = useLocationFilter();
  const { t } = useLang();
  const [city, setCity] = useState(null);

  useEffect(() => {
    if (!gps) { setCity(null); return; }
    api.get("/cities/nearest", { params: { lat: gps.lat, lng: gps.lng } })
      .then((r) => {
        const c = r.data.city;
        if (!c) { setCity(null); return; }
        if (localStorage.getItem("lp-city-banner-off") === `${c.countrySlug}/${c.citySlug}`) return;
        setCity(c);
      })
      .catch(() => {});
  }, [gps]);

  if (!city) return null;
  const dismiss = () => {
    localStorage.setItem("lp-city-banner-off", `${city.countrySlug}/${city.citySlug}`);
    setCity(null);
  };

  return (
    <div className="flex items-center gap-3 rounded-2xl border border-[#16a34a]/30 bg-[#e7f6ec] dark:bg-[#16341f] px-4 py-3"
      data-testid="nearest-city-banner">
      <MapPin size={18} className="text-[#16a34a] shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-foreground" data-testid="nearest-city-title">
          {t("loc.nearCity", { city: city.city })}
        </p>
        <p className="text-xs text-muted-foreground">
          {city.dealCount === 1 ? t("city.liveDealOne") : t("city.liveDeals", { n: city.dealCount })}
        </p>
      </div>
      <Link to={`/${city.countrySlug}/${city.citySlug}`} data-testid="nearest-city-link"
        className="inline-flex items-center gap-1.5 rounded-xl bg-[#16a34a] hover:bg-[#15803d] text-white text-sm font-bold px-3.5 py-2 transition-colors shrink-0">
        {t("loc.seeThoseDeals")} <ArrowRight size={14} />
      </Link>
      <button onClick={dismiss} data-testid="nearest-city-dismiss" aria-label="Dismiss"
        className="text-muted-foreground hover:text-foreground transition-colors shrink-0">
        <X size={16} />
      </button>
    </div>
  );
};

export default NearestCityBanner;
